import { Subject } from 'rxjs';
import { Config } from '../../config';
import { IUpSellQuantityChangeResponse } from '../../config/upsell-response';
import { QuantityValidator } from '../../validators/quantity-validator';
import { Validator } from '../../validators/validator';
import { UpSellQuantityView } from '../../view/upsell/upsell-quantity-view';
import { Form } from '../form';

export class UpSellQuantityForm extends Form {
    productName = '';
    quantity = 1;
    previousQuantity = 1;
    view: UpSellQuantityView = new UpSellQuantityView();
    validator: Validator = new QuantityValidator();


    constructor(prodName: string) {
        super();
        this.productName = prodName;
        this.validators.push(this.validator);
    }

    async init(config: Config, callbacks: any, subject: Subject<IUpSellQuantityChangeResponse>) {
        await super.init(config, callbacks);
        this.parentSubject = subject;
        return Promise.resolve();
    }

    async render() {
        this.view.renderQuantityForm(this.setQuantity.bind(this), this.productName);
    }

    private setQuantity(quantity: number, id?: string): void {
        this.previousQuantity = this.quantity;
        this.quantity = quantity;
        this.paymentData.quantity = quantity;

        this.validate();
        if (this.parentSubject) {
            this.parentSubject.next({ productName: this.productName, quantity: this.quantity, paymentQuantity: this.paymentData.quantity });
        }
    }

    public get formQuantity() {
        return this.quantity;
    }

    resetQuantity() {
        return this.view.resetQuantity();
    }

    validate = async () => {
        this.view.hideError();
        const validatorResult = this.validator.validate({ id: this.view.id });
        const isValid = await validatorResult;
        if (!isValid) {
            this.view.showError();
        }
        return validatorResult;
    }

}
